// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58de54f7","453":"8460927b","455":"88603bf7","977":"d59291a1"}[chunkId] + ".chunk.js";
};